import { createSlice } from '@reduxjs/toolkit'
import { ethers } from 'ethers';
import { abi, contractAddress, tuesdayAbi, tuesdayContractAddress } from '../../constants/abi';
import { usdtAbi, usdtContractAddress } from '../../constants/usdtAbi';

const initialState = {
    connect: false,
    accountAddress: '',
    
}

export const providerSlice = createSlice({
    name: 'provider',
    initialState,
    reducers: {
        connect: (state, action) => {
            // console.log('connect', action.payload);å
            return {
                connect: true,provider:action.payload.provider,signer:action.payload.signer,accountAddress:action.payload.address,
                lotteryContract:new ethers.Contract(contractAddress,abi,action.payload.signer),
                usdtContract:new ethers.Contract(usdtContractAddress,usdtAbi,action.payload.signer),
                tuesdayContract:new ethers.Contract(tuesdayContractAddress,tuesdayAbi,action.payload.signer),
            }
        },
        disconnect: (state) => {
            return { connect: false }
        },
        accountChange: (state, action) => {
            return { ...state, accountAddress: action.payload }
        },
    },
})

// Action creators are generated for each case reducer function
export const { connect, disconnect, accountChange } = providerSlice.actions

export default providerSlice.reducer